import qs from "qs";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { authLogin } from "../../features/auth/redux/auth.actions";

const AuthCallback = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const { code } = qs.parse(window.location.search, {
            ignoreQueryPrefix: true,
        });

        dispatch(authLogin(code as string));
    }, []);

    return null;
};

export default AuthCallback;
